import LabelledDivRow from "components/LabelledDivRow";
import React from "react";

interface Props {
  version: server.dto.Version.VersionDiagnostic
}

const VersionRows = ({ version }: Props) => {
  return <>
    <LabelledDivRow label="Environment">
      {version.environment}
    </LabelledDivRow>
    <LabelledDivRow label="Debug mode">
      {version.debug.toString()}
    </LabelledDivRow>

    <LabelledDivRow label="Build type">
      {version.isLocalBuild ? "Local build" : "Production build"}
    </LabelledDivRow>

    {!version.isLocalBuild && <>
      <LabelledDivRow label="GitHub commit">
        <a target="_blank" rel="noreferrer" style={{ overflowWrap: "anywhere" }} href={version.gitHubCommitUrl}>{version.gitHubCommitHash}</a>
      </LabelledDivRow>

      <LabelledDivRow label="Azure DevOps build nr">
        <a target="_blank" rel="noreferrer" href={version.devOpsUrl}>{version.buildNumber}</a>
      </LabelledDivRow>
    </>}
  </>;
};

export default VersionRows;